// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__16vFj","right":"styles_right__25rF5"};